import { useState, useEffect } from 'react';
import { AdminLayout } from './AdminDashboard';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = () => { setLoading(true); axios.get(`${API}/admin/appointments`, { withCredentials: true }).then(r => setAppointments(r.data.appointments)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { fetch(); }, []);

  const updateStatus = async (id, status) => {
    try { await axios.put(`${API}/admin/appointments/${id}/status`, { status }, { withCredentials: true }); toast.success('Updated'); fetch(); } catch { toast.error('Failed'); }
  };

  if (loading) return <AdminLayout active="/admin/appointments"><div className="flex justify-center py-20"><div className="spinner"></div></div></AdminLayout>;

  return (
    <AdminLayout active="/admin/appointments">
      <div data-testid="admin-appointments">
        <h1 className="font-heading text-3xl font-bold text-dark-brown mb-8">Appointments</h1>
        {appointments.length === 0 ? <div className="text-center py-20 font-body text-light-brown">No appointments yet</div> : (
          <div className="space-y-4">
            {appointments.map(a => (
              <div key={a.id} className="bg-white rounded-xl border border-border-custom p-5" data-testid={`admin-apt-${a.id}`}>
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div>
                    <div className="font-body font-medium text-dark-brown">{a.service_name}</div>
                    <div className="font-body text-xs text-light-brown">{a.user_name} ({a.user_email})</div>
                    <div className="font-body text-sm text-mid-brown mt-1">{a.date} &middot; {a.start_time} - {a.end_time}</div>
                    {a.pet_name && <div className="font-body text-xs text-light-brown mt-0.5">Pet: {a.pet_name}</div>}
                    {a.notes && <div className="font-body text-xs text-light-brown">Notes: {a.notes}</div>}
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="font-bold text-[#212121]" style={{ fontFamily: 'Roboto, sans-serif', fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.02em' }}>{'\u20B9'}{a.price}</span>
                    <Select value={a.status} onValueChange={v => updateStatus(a.id, v)}>
                      <SelectTrigger className={`w-[130px] rounded-full text-xs font-body ${a.status === 'confirmed' ? 'bg-green-100 text-green-800' : a.status === 'completed' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'}`}>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="confirmed">Confirmed</SelectItem>
                        <SelectItem value="completed">Completed</SelectItem>
                        <SelectItem value="cancelled">Cancelled</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
